/* NESCENTCITY — video testimonials
   Carousel arrows + dots. Uploaded videos pause each other so only one
   clip plays at a time. Embeds render natively with their own players. */
(function () {
  'use strict';

  /* only one uploaded clip at a time */
  document.querySelectorAll('.vt__media video').forEach(function (v) {
    v.addEventListener('play', function () {
      document.querySelectorAll('.vt__media video').forEach(function (other) {
        if (other !== v) { try { other.pause(); } catch (e) {} }
      });
    });
  });

  /* ---------- carousel ---------- */
  document.querySelectorAll('.vt').forEach(function (sec) {
    var track = sec.querySelector('[data-vt-track]');
    if (!track) return;
    var items = track.children;
    if (!items.length) return;

    var dots = sec.querySelector('[data-vt-dots]');
    if (dots && !dots.children.length) {
      for (var i = 0; i < items.length; i++) {
        var d = document.createElement('span');
        d.className = 'vt__dot-i' + (i === 0 ? ' is-on' : '');
        dots.appendChild(d);
      }
    }

    function offsetOf(i) { return items[i].offsetLeft - items[0].offsetLeft; }

    function index() {
      var x = track.scrollLeft, best = 0, bestD = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(offsetOf(i) - x);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }

    function go(n) {
      var t = Math.min(items.length - 1, Math.max(0, n));
      if (track.scrollTo) track.scrollTo({ left: offsetOf(t), behavior: 'smooth' });
      else track.scrollLeft = offsetOf(t);
    }

    var prev = sec.querySelector('[data-vt-prev]');
    var next = sec.querySelector('[data-vt-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(index() - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(index() + 1); });

    var ticking;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var n = index();
        if (dots) {
          for (var i = 0; i < dots.children.length; i++) {
            dots.children[i].classList.toggle('is-on', i === n);
          }
        }
        ticking = false;
      });
    });
  });
})();
